import { render, staticRenderFns } from "./TrendingWidget.vue?vue&type=template&id=fe927fae"
import script from "./TrendingWidget.vue?vue&type=script&lang=js"
export * from "./TrendingWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports